// Translations
import landing from '../views/landing/translations/ru'

// Translation: Error (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
